if (!customElements.get('skm-mix-library')) {
  customElements.define('skm-mix-library', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const { signal } = this.controller;
      const rows = [...this.querySelectorAll('[data-mix-row]')];
      if (!rows.length) return;
      const search = this.querySelector('[data-mix-search]');
      const genre = this.querySelector('[data-mix-genre]');
      const status = this.querySelector('[data-mix-status]');
      const empty = this.querySelector('[data-mix-empty]');
      const reset = this.querySelector('[data-mix-reset]');
      const more = this.querySelector('[data-mix-more]');
      let expanded = false;
      const normalize = text => text.normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
      for (const option of [...genre.options]) {
        if (option.value !== 'all' && !rows.some(row => row.dataset.genre === option.value)) option.remove();
      }
      const filter = () => {
        const terms = normalize(search.value).trim().split(/\s+/).filter(Boolean);
        let count = 0;
        let total = 0;
        for (const row of rows) {
          const match = (genre.value === 'all' || row.dataset.genre === genre.value) && terms.every(term => normalize(row.dataset.title).includes(term));
          if (match) total++;
          row.hidden = !match || (!expanded && count >= 6);
          if (!row.hidden) count++;
          else row.querySelector('audio').pause();
        }
        status.textContent = this.dataset.countTemplate.replace('[count]', String(count)).replace('[total]', String(total));
        more.hidden = count >= total;
        empty.hidden = count !== 0;
        reset.hidden = !search.value && genre.value === 'all';
      };
      search.addEventListener('input', () => { expanded = false; filter(); }, { signal });
      genre.addEventListener('change', () => { expanded = false; filter(); }, { signal });
      more.addEventListener('click', () => { expanded = true; filter(); }, { signal });
      reset.addEventListener('click', () => { search.value = ''; genre.value = 'all'; expanded = false; filter(); search.focus(); }, { signal });
      document.addEventListener('play', event => {
        if (!(event.target instanceof HTMLAudioElement) || !event.target.closest('skm-mix-library')) return;
        document.querySelectorAll('skm-mix-library audio').forEach(audio => { if (audio !== event.target) audio.pause(); });
      }, { capture: true, signal });
      this.querySelectorAll('audio').forEach(audio => {
        audio.addEventListener('error', () => { audio.parentElement.classList.add('skm-player-error'); }, { signal });
      });
      this.querySelector('[data-mix-controls]').hidden = false;
      filter();
    }
    disconnectedCallback() { this.controller?.abort(); this.controller = null; }
  });
}
